<template>
    <div class="container">

        <div v-if="authorStore.loading">Loading data...</div>
        <div v-if="authorStore.error">{{ authorStore.error }}</div>

       <!-- Kryesia -->

        <div v-if="!authorStore.loading && !authorStore.error && authorStore.kryesuesit.length > 0">
            <titleArea :title="this.$t('autoret.prokurorettitujt.kryesia')" v-if="subdomain !== 'kpk'"/>
            <div class="row mt-4">
                <div
                    v-for="autor in authorStore.kryesuesit"
                    :key="autor.id"
                    class="col-12 col-md-6 col-lg-4 mb-4">
                    <ProfileCard
                        :title="autor.categoryName"
                        :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName"
                        :position="autor.postionName"
                        :birthday="autor.birthdate"
                        :address="autor.address"
                        :cv_text="autor.description"
                        :cv_url="autor.cvUrl"
                        facebook="#"
                        @primary="pranoFunksioni"
                        @secondary="anuloFunksioni"/>
                </div>
            </div>
        </div>

        <!-- Zëvendëskryesuesit -->
        <div v-if="!authorStore.loading && !authorStore.error && authorStore.zevendeskryesuesit.length > 0">
            <!-- <titleArea title="Zëvendëskryesuesja" /> -->

            <titleArea :title="this.$t('autoret.prokurorettitujt.zevendskryesusi')" v-if="subdomain !== 'kpk'"/>
            <div class="row mt-4">
                <div
                    v-for="autor in authorStore.zevendeskryesuesit"
                    :key="autor.id"
                    class="col-12 col-md-6 col-lg-4 mb-4">
                    <!-- <Persecutor
                        :title="autor.postionName"
                        :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName"
                        :position="autor.postionName"
                        :birthday="autor.birthdate"
                        :address="autor.address"
                        :cv_text="autor.description"
                        :cv_url="autor.cvUrl"
                        facebook="#"
                        @primary="pranoFunksioni"
                        @secondary="anuloFunksioni"/> -->
                    <ProfileCard
                        :title="autor.postionName"
                        :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName"
                        :position="autor.postionName"
                        :birthday="autor.birthdate"
                        :address="autor.address"
                        :cv_text="autor.description"
                        :cv_url="autor.cvUrl"
                        facebook="#"
                        @primary="pranoFunksioni"
                        @secondary="anuloFunksioni"/>
                </div>
            </div>
        </div>

        <!-- Ish-Kryesuesit -->
        <div v-if="!authorStore.loading && !authorStore.error && authorStore.ishkryesuesit.length > 0">
            <!-- <titleArea title="Ish-Kryesuesit" /> -->
            <titleArea :title="this.$t('autoret.prokurorettitujt.ishKryesuesi')" />
            <div class="row mt-4">
                <div
                    v-for="autor in authorStore.ishkryesuesit"
                    :key="autor.id"
                    class="col-12 col-md-6 col-lg-4 mb-4">
                    <ProfileCard
                        title=""
                        :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName"           
                        :birthday="autor.birthdate"
                        :address="autor.address"
                        :cv_text="autor.description"
                        :cv_url="autor.cvUrl"
                        facebook="#"
                        @primary="pranoFunksioni"
                        @secondary="anuloFunksioni"/>
                </div>
            </div>
        </div>

        <!-- Ish-Zëvendëskryesuesit -->
        <div v-if="!authorStore.loading && !authorStore.error && authorStore.ishzevendeskryesuesit.length > 0">
            <!-- <titleArea title="Ish-Zëvendëskryesuesit" /> -->
            <!-- <titleArea :title="this.$t('autoret.prokurorettitujt.ishZevendskryesusi')" /> -->
            <div class="row mt-4">
                <div
                    v-for="autor in authorStore.ishzevendeskryesuesit"
                    :key="autor.id"
                    class="col-12 col-md-6 col-lg-4 mb-4">
                    <ProfileCard
                        :title="autor.postionName"
                        :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName"
                        :position="autor.postionName"
                        :birthday="autor.birthdate"
                        :address="autor.address"
                        :cv_text="autor.description"
                        :cv_url="autor.cvUrl"
                        facebook="#"
                        @primary="pranoFunksioni"
                        @secondary="anuloFunksioni"/>
                </div>
            </div>
        </div>
        <!-- end of kryesia -->

        <!-- start of Antarsia  -->
        <!-- KRYESUESI -->
        <div v-if="!authorStore.loading && !authorStore.error && authorStore.antertkshillitKryesuesi.length > 0">
            <!-- <titleArea title="Kryesuesi" /> -->
            <titleArea :title="this.$t('autoret.prokurorettitujt.kryesuesi')" />
            <div class="row mt-4">
                <div v-for="autor in authorStore.antertkshillitKryesuesi" :key="autor.id"
                    class="col-12 col-md-6 col-lg-4 mb-4">
                    <ProfileCard :title="autor.categoryName" :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName" :cv_url="autor.cvUrl"
                        :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" facebook="#"
                        @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                </div>
            </div>
        </div>

        <!-- ANËTARËT E KËSHILLIT -->
        <div v-if="!authorStore.loading && !authorStore.error && authorStore.antertkshillit.length > 0">
            <!-- <titleArea title="Anëtarët e Këshillit" /> -->
            <titleArea :title="this.$t('autoret.prokurorettitujt.anetaret')" />
            <div class="row mt-4">
                <div v-for="autor in authorStore.antertkshillit" :key="autor.id" class="col-12 col-md-6 col-lg-4 mb-4">
                    <!-- <Persecutor :title="autor.postionName" :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                        :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                        :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" /> -->

         <ProfileCard  :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName" :cv_url="autor.cvUrl"
                        :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" facebook="#"
                        @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                           <!-- <Persecutor title="" :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                        :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                        :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" /> -->
                </div>
            </div>
        </div>

        <!-- ADMINISTRATA -->
        <div v-if="!authorStore.loading && !authorStore.error && authorStore.antaretadministrata.length > 0">
            <!-- <titleArea title="Administrata" /> -->
            <!-- <titleArea :title="this.$t('autoret.prokurorettitujt.administrata')" /> -->
            <div class="row mt-4">
                <div v-for="autor in authorStore.antaretadministrata" :key="autor.id"
                    class="col-12 col-md-6 col-lg-4 mb-4">
                    <!-- <Persecutor :title="autor.postionName" :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                        :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                        :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" /> -->

         <ProfileCard  :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName" position="" :cv_url="autor.cvUrl"
                        :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" facebook="#"
                        @primary="pranoFunksioni" @secondary="anuloFunksioni" />

                            <!-- <Persecutor title="" :avatar="autor.imageUrl"
                        :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                        :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                        :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" /> -->
                </div>
            </div>
        </div>
        <!-- end of Anetaret -->

        <!-- start of Kryprokuroa  -->
        <div v-if="this.$route.params.categoryId === '100'">

            <div class="row mt-4">
                <div v-if="!authorStore.loading && !authorStore.error && authorStore.kryeprokurori.length > 0">
                    <!-- <titleArea title="Kryeprokurori" /> -->
                    <titleArea :title="this.$t('autoret.prokurorettitujt.kryeprokurori')" />
                    <div class="col-12 col-md-6 col-lg-4 mb-4">
                        <div v-for="autor in authorStore.kryeprokurori" :key="autor.id">
                            <ProfileCard :title="autor.categoryName" :avatar="autor.imageUrl"
                                :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                                :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" :cv_url="autor.cvUrl"
                                facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.ishKryeprokuri.length > 0">
                <!-- <titleArea title="Ish-Kryeprokurorët" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.ishKryeprokurori')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.ishKryeprokuri" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" 
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>
        </div>




        <!-- start of Prokuroret  -->
        <div v-if="this.$route.params.categoryId === '106'">
            <div class="row mt-4">
                <div v-if="!authorStore.loading && !authorStore.error && authorStore.zevndesKryeprokuri.length > 0">
                    <!-- <titleArea title="Zv.Kryeprokurorja" /> -->
                    <titleArea :title="this.$t('autoret.prokurorettitujt.zvkryeprokurori')" />
                    <div class="col-12 col-md-6 col-lg-4 mb-4">
                        <div v-for="autor in authorStore.zevndesKryeprokuri" :key="autor.id">
                            <ProfileCard :title="autor.categoryName" :avatar="autor.imageUrl"
                                :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName" :cv_url="autor.cvUrl"
                                :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                                facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.prokuroeret.length > 0">
                <!-- <titleArea title="Prokurorët" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.prokuroret')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.prokuroeret" :key="autor.id" class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" 
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.departamenitkrimeTeRenda.length > 0">
                <!-- <titleArea title="Departamenti për Krime të Rënda" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.departamentiKrimeTeRenda')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.departamenitkrimeTeRenda" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" 
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.deparatamentiTeMitur.length > 0">
                <!-- <titleArea title="Departamenti për të mitur" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.departamentiPerTeMitur')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.deparatamentiTeMitur" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" 
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.deparatamentiPergjitheshem.length > 0">
                <!-- <titleArea title="Departamenti i përgjithshëm" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.departamentiPergjitheshem')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.deparatamentiPergjitheshem" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" 
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.departamenitkrimeTeLuftes.length > 0">
                <titleArea :title="this.$t('autoret.prokurorettitujt.departamentiKrimeveLuftes')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.departamenitkrimeTeLuftes" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" 
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.deparatamentiHetimKrimeOrganizuara.length > 0">
                <!-- <titleArea title="Departamenti për hetimin e Krimit të Organizuar" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.departamentiKrimeveTeOrganizuara')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.deparatamentiHetimKrimeOrganizuara" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description" 
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.departamenitHetimETerorizimit.length > 0">
                <!-- <titleArea title="Departamenti për hetimin e Terrorizmit" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.departamentiTerorizem')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.departamenitHetimETerorizimit" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>

            <div v-if="!authorStore.loading && !authorStore.error && authorStore.deparatamentiKorrupcionFinancaiar.length > 0">
                <!-- <titleArea title="Departamenti për hetimin e Korrupsionit dhe Krimit Financiar" /> -->
                <titleArea :title="this.$t('autoret.prokurorettitujt.departamentiKorrupsionFinanciar')" />
                <div class="row mt-4">
                    <div v-for="autor in authorStore.deparatamentiKorrupcionFinancaiar" :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName"
                            :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                            :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />
                    </div>
                </div>
            </div>
        </div>




<!-- end of prokuroeret -->

<!-- Start of kordinatoret -->

        <div v-if="this.$route.params.categoryId==='111' ">
            <div v-if="!authorStore.loading && !authorStore.error && authorStore.kordinatoret.length > 0">
                <!-- <h4 class="mt-4">Kordinatoret</h4> -->
                <h4 class="mt-4">{{this.$t('autoret.prokurorettitujt.kordinatoret')}}</h4>
                <div class="row mt-4">
                    <div
                        v-for="autor in authorStore.kordinatoret"
                        :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <!-- <ProfileCard
                            :title="autor.categoryName"
                            :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName"
                            :position="autor.postionName"
                            :birthday="autor.birthdate"
                            :address="autor.address"
                            :cv_text="autor.description"
                            facebook="#"
                            @primary="pranoFunksioni"
                            @secondary="anuloFunksioni"/> -->

                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                                :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName" :email="autor.email"
                                :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                                :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />

                    </div>
                </div>
  </div>
        </div>

     <div v-if="this.$route.params.categoryId==='2210' ">
            <div v-if="!authorStore.loading && !authorStore.error && authorStore.administrata.length > 0">
                <!-- <h4 class="mt-4">Kordinatoret</h4> -->
                <h4 class="mt-4">{{this.$t('autoret.prokurorettitujt.administrata')}}</h4>
                <div class="row mt-4">
                    <div
                        v-for="autor in authorStore.administrata"
                        :key="autor.id"
                        class="col-12 col-md-6 col-lg-4 mb-4">
                        <!-- <ProfileCard
                            :title="autor.categoryName"
                            :avatar="autor.imageUrl"
                            :fullname="autor.firstName + ' ' + autor.lastName"
                            :position="autor.postionName"
                            :birthday="autor.birthdate"
                            :address="autor.address"
                            :cv_text="autor.description"
                            facebook="#"
                            @primary="pranoFunksioni"
                            @secondary="anuloFunksioni"/> -->

                        <ProfileCard :title="autor.postionName" :avatar="autor.imageUrl"
                                :fullname="autor.firstName + ' ' + autor.lastName" :position="autor.postionName" :email="autor.email"
                                :birthday="autor.birthdate" :address="autor.address" :cv_text="autor.description"
                                :cv_url="autor.cvUrl" facebook="#" @primary="pranoFunksioni" @secondary="anuloFunksioni" />

                    </div>
                </div>



                <!-- <div class="row mt-4">
                    <div v-for="autor in authorStore.kordinatoret" :key="autor.id"
                        class="col-12 col-md-6 col-lg-3 mb-4">
                         <Persecutor 
                :title="autor.postionName" 
                :avatar="autor.imageUrl"
                :fullname="autor.firstName + ' ' + autor.lastName" 
                :position="autor.postionName"
                :birthday="autor.birthdate" 
                :address="autor.address" 
                :cv_text="autor.description"
                :cv_url="autor.cvUrl" 
                facebook="#" 
                @primary="pranoFunksioni" 
                @secondary="anuloFunksioni" />
                    </div>
                </div> -->
            </div>
        </div>
             <!-- end of kordinatoret -->
    </div>
</template>

<script>
import ProfileCard from '../share/PresecutorChiefTemplate.vue';
//import Persecutor from '../share/PersecutorTemplate.vue';
import titleArea from '../../components/share/TitleArea.vue';
import { useAutorStore } from '@/store/AuthorStore/authorStore';



export default {
  data() {
    return {
      authorStore: useAutorStore(),
      prokuroriaId: 4,
      language: 'AL',
      subdomain:''
    };
  },
  components: {
    ProfileCard,
    //Persecutor,
    titleArea,
  },
  created() {
    this.fetchDataForCategory(this.$route.params.categoryId);
  },
  mounted(){
    this.getSubdomain();
  },
  watch: {
    // Watch for changes to the route's categoryId
    '$route.params.categoryId'(newCategoryId) {
      this.fetchDataForCategory(newCategoryId);
    },
  },
  methods: {
    getSubdomain() {
        const host = window.location.hostname;
        this.subdomain = '';
        if (host.includes('.')) {
            this.subdomain = host.split('.')[0];
        }
    },
    pranoFunksioni() {
      console.log('Pranoj');
    },
    anuloFunksioni() {
      console.log('Mbyll');
    },
    // Reset relevant store state to avoid stale data
    resetStoreState() {
      this.authorStore.kryesuesit = [];
      this.authorStore.zevendeskryesuesit = [];
      this.authorStore.ishkryesuesit = [];
      this.authorStore.ishzevendeskryesuesit = [];
      this.authorStore.antertkshillitKryesuesi = [];
      this.authorStore.antertkshillit = [];
      this.authorStore.antaretadministrata = [];
      this.authorStore.kryeprokurori = [];
      this.authorStore.ishKryeprokuri = [];
      this.authorStore.zevndesKryeprokuri = [];
      this.authorStore.prokuroeret = [];
      this.authorStore.departamenitkrimeTeRenda = [];
      this.authorStore.deparatamentiTeMitur = [];
      this.authorStore.deparatamentiPergjitheshem = [];
      this.authorStore.kordinatoret = [];
      this.authorStore.departamenitkrimeTeLuftes= [];
      this.authorStore.deparatamentiHetimKrimeOrganizuara=[];
      this.authorStore.departamenitHetimETerorizimit=[];
      this.authorStore.deparatamentiKorrupcionFinancaiar=[];
            this.authorStore.administrata = [];
      this.authorStore.loading = false;
      this.authorStore.error = null;

 
    },
    // Centralized method to fetch data based on categoryId
    fetchDataForCategory(categoryId) {
      // Reset store state before fetching new data
      this.resetStoreState();

      const postsData = {
        prokuroriaId: categoryId === '100' || categoryId === '106' || categoryId === '111' ? 5 : this.prokuroriaId,
        categoryId: categoryId,
        positionId: 0,
        language: this.language,
      };

      if (categoryId === '76') {
        this.authorStore.getKryesuesit(postsData);
        this.authorStore.getZevendeskryesuesit({ ...postsData, categoryId: 77 });
        this.authorStore.getIshkryesuesit({ ...postsData, categoryId: 78 });
        this.authorStore.getIshZevendeskryesuesit({ ...postsData, categoryId: 79 });
      } else if (categoryId === '85') {
        this.authorStore.getAntaretkshillitKryesuesi(postsData);
        this.authorStore.getAntaretkshillit({ ...postsData, categoryId: 86 });
        this.authorStore.getAntaretadministrata({ ...postsData, categoryId: 94 });
      } else if (categoryId === '100') {
        this.authorStore.getKryeProkuroret(postsData);
        this.authorStore.getIShKryeProkuroret({ ...postsData, categoryId: 102 });
      } else if (categoryId === '106') {
        this.authorStore.getZavendesKryeProkuroret({ ...postsData, categoryId: 107 });
        this.authorStore.getProkuroretLista(postsData);
        this.authorStore.getDeparmentiKrimeTeRenda({ ...postsData, categoryId: 108 });
        this.authorStore.getDeparmentiTeMitur({ ...postsData, categoryId: 109 });
        this.authorStore.getDeparmentiPergjitheshem({ ...postsData, categoryId: 110 });
        this.authorStore.getDepartamenitkrimeTeLuftes({ ...postsData, categoryId: 124 });
        this.authorStore.getDeparatamentiHetimKrimeOrganizuara({ ...postsData, categoryId: 127 });
        this.authorStore.getDepartamenitHetimETerorizimit({ ...postsData, categoryId: 129 });
        this.authorStore.getDeparatamentiKorrupcionFinancaiar({ ...postsData, categoryId: 131 });
      } else if (categoryId === '111') {
        this.authorStore.getKordinatoret(postsData);
      }
      else if(categoryId === '2210'){
        this.authorStore.getAdministratoret(postsData);
      }
    },
  },
};
</script>